import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { appUserSlice, hasUserStateCookie } from "api/slices/appUser";
import * as qs from "qs";

import type { RootState } from "../lib/store";

const BASE_URL = process.env.REACT_APP_BIOT_URL ?? "https://mock.biot.example.com";

export const nextBaseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: async (headers, api) => {
    if (hasUserStateCookie()) {
      const state = (api.getState() as RootState)[appUserSlice.name];
      const { accessToken, locale } = state;
      headers.set("Accept-Language", locale);
      if (accessToken) {
        headers.set("Authorization", `Bearer ${accessToken}`);
      }
      return headers;
    }
  },
  paramsSerializer: (params) =>
    qs.stringify(params, {
      arrayFormat: "repeat",
    }),
});

export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const result = await nextBaseQuery(args, api, extraOptions);
  if (!result.error || result.error.status !== 401) {
    return result;
  }

  if (!hasUserStateCookie()) {
    return result;
  }
  const { refreshToken: currentRefreshToken } = (api.getState() as RootState)[appUserSlice.name];

  if (!currentRefreshToken) {
    return result;
  }
  const response = await fetch(`${BASE_URL}/ums/v2/users/token/refresh`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      refreshToken: currentRefreshToken,
    }),
  });
  const refreshResponse = await response.json();

  const accessToken = refreshResponse?.accessJwt?.token ?? "";
  const refreshToken = refreshResponse?.refreshJwt?.token ?? "";
  if (!accessToken || !refreshToken) {
    return result;
  }

  api.dispatch(
    appUserSlice.actions.setTokens({
      accessToken,
      refreshToken,
      accessTokenExpiry: refreshResponse.accessJwt.expiration,
      refreshTokenExpiry: refreshResponse.refreshJwt.expiration,
    })
  );
  return nextBaseQuery(args, api, extraOptions);
};

export const baseQueriesApi = createApi({
  baseQuery,
  tagTypes: [],
  endpoints: () => ({}),
});
